import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';
import $ from 'jquery';

Vue.use(VueFormGenerator);

export default {

  name: 'StepThanks',

  inject: [
    'storageData',
    'clearCart',
    'stepValidation',
    'sendConfirmation',
    'sendOrder',
    'getEventByUuid'
  ],

  data () {
    return {
      orderData: [],
      defaultParticipantFormData: [],
      defaultBillingFormData: [],
      generatingPdf: false
    };
  },

  computed: {

  },

  methods: {
    writeOrderData: function () {
      this.orderData = JSON.parse(JSON.stringify(this.storageData));
      this.defaultParticipantFormData = this.orderData.forms.stepTwo[Object.keys(this.orderData.forms.stepTwo)[0]].participantData;
      this.defaultBillingFormData = this.orderData.forms.stepTwo[Object.keys(this.orderData.forms.stepTwo)[0]].billingAddress;

      this.clearCart();
    },
    saveSummary: function () {
      this.generatingPdf = true;
      // use browser print option as html2canvas and jspdf do not work with most browsers in iframe
      window.print();

      this.generatingPdf = false;
    }
  },

  created () {
    this.$parent.$off('validateCurrentStep').$on('validateCurrentStep', this.validateStep);
  },

  mounted () {
    this.writeOrderData();
    Vue.set(this.stepValidation, 'triedToValidateStep', false);
    Vue.set(this.stepValidation, 'isValid', true);
  }

};



// WEBPACK FOOTER //
// ./src/apps/booking/components/bookingSteps/defaultSteps/5/StepThanks.js